export interface RAImageParam {
  rawFile: File
}

export function isRAImage(param: string | RAImageParam): param is RAImageParam {
  return (param as RAImageParam).rawFile !== undefined;
}

